import dayjs from 'dayjs';
import moment from 'moment';
import { setHrAxiosLocale } from '@helloworld1812/hr-api';
import { WsLanguage } from '@helloworld1812/ws-i18n';
import { TOptions } from 'i18next';

import 'dayjs/locale/fr';
import 'dayjs/locale/zh';
import 'moment/locale/fr';
import 'moment/locale/zh-cn';

export type Language = WsLanguage;

const momentLocaleByLanguage: Record<Language, string> = {
  en: 'en',
  fr: 'fr',
  zh: 'zh-cn',
  es: 'es',
};

export const i18nInstance = window.__WS_CTX__.i18nInstance;

export const set3rdPartyLanguage = (language: Language) => {
  dayjs.locale(language);
  setHrAxiosLocale(language);
  moment.locale(momentLocaleByLanguage[language] ?? 'en');
};

export const glossaryT = (key: string, optionsOrDefaultValue?: string | TOptions) => {
  const options =
    typeof optionsOrDefaultValue === 'string' ? { defaultValue: optionsOrDefaultValue } : optionsOrDefaultValue;
  return i18nInstance.t(key, {
    ns: 'glossary',
    ...options,
  });
};
